export const inoutTransactionsList = {
  totalCount: 10,
  groupCount: -1,
  data: [
    {
      id: 1001,
      type: 1,
      date: '2025-03-15T10:22:00.000Z',
      paymentMethod: 1,
      bankTransferType: 'Standard',
      amount: 276543.99,
      commission: 0.0,
      senderIntId: 42,
      senderExtId: 'ACC001',
      senderFirstName: 'Jane',
      senderLastName: 'Cooper',
      senderEmail: 'jane@company.com',
      senderBalance: 300000.0,
      senderIsCompany: false,
      senderCompanyName: null,
      receiverIntId: null,
      receiverExtId: null,
      receiverFirstName: null,
      receiverLastName: null,
      receiverEmail: null,
      receiverBalance: null,
      receiverIsCompany: null,
      receiverCompanyName: null,
      status: 'p3',
      statusBank: null,
      comment: 'Card money-in',
      isChargebackRelated: false,
      delayedDays: 0,
      rib: null,
      wkToken: null,
      merchantToken: null,
      sddMandate: null,
      collectionDate: null,
      settlementDate: '2025-03-15T12:00:00.000Z',
      scheduledDate: null,
      parentTransactionId: null,
      moneyOutId: null,
      HolderAuthenticationType: null,
      ChallengeMode: null,
      psp: null,
      pspError: null,
      PspReference: null,
      AccountBalance: null,
      category: 0,
      PaymentMeanDataProvider: null,
      Currency: 'EUR'
    },
    {
      id: 1002,
      type: 1,
      date: '2025-03-14T09:15:00.000Z',
      paymentMethod: 3,
      bankTransferType: null,
      amount: 17.0,
      commission: 0.0,
      senderIntId: 42,
      senderExtId: 'ACC001',
      senderFirstName: 'Jane',
      senderLastName: 'Cooper',
      senderEmail: 'jane@company.com',
      senderBalance: null,
      senderIsCompany: false,
      senderCompanyName: null,
      receiverIntId: null,
      receiverExtId: null,
      receiverFirstName: null,
      receiverLastName: null,
      receiverEmail: null,
      receiverBalance: null,
      receiverIsCompany: null,
      receiverCompanyName: null,
      status: '0',
      statusBank: null,
      comment: 'Card chargeback',
      isChargebackRelated: true,
      delayedDays: 0,
      rib: null,
      wkToken: null,
      merchantToken: null,
      sddMandate: null,
      collectionDate: null,
      settlementDate: '2025-03-14T11:00:00.000Z',
      scheduledDate: null,
      parentTransactionId: null,
      moneyOutId: null,
      HolderAuthenticationType: null,
      ChallengeMode: null,
      psp: null,
      pspError: null,
      PspReference: null,
      AccountBalance: null,
      category: 3,
      PaymentMeanDataProvider: null,
      Currency: 'EUR'
    },
    {
      id: 1003,
      type: 1,
      date: '2025-03-13T14:30:00.000Z',
      paymentMethod: 2,
      bankTransferType: null,
      amount: 173.45,
      commission: 0.0,
      senderIntId: 11,
      senderExtId: 'SC',
      senderFirstName: null,
      senderLastName: null,
      senderEmail: null,
      senderBalance: null,
      senderIsCompany: null,
      senderCompanyName: null,
      receiverIntId: 42,
      receiverExtId: 'ACC001',
      receiverFirstName: 'Jane',
      receiverLastName: 'Cooper',
      receiverEmail: 'jane@company.com',
      receiverBalance: null,
      receiverIsCompany: null,
      receiverCompanyName: null,
      status: 'p1',
      statusBank: null,
      comment: 'Lemonway commission',
      isChargebackRelated: false,
      delayedDays: 0,
      rib: null,
      wkToken: null,
      merchantToken: null,
      sddMandate: null,
      collectionDate: null,
      settlementDate: null,
      scheduledDate: null,
      parentTransactionId: null,
      moneyOutId: null,
      HolderAuthenticationType: null,
      ChallengeMode: null,
      psp: null,
      pspError: null,
      PspReference: null,
      AccountBalance: null,
      category: 6,
      PaymentMeanDataProvider: null,
      Currency: 'EUR'
    },
    {
      id: 1004,
      type: 1,
      date: '2025-03-12T08:00:00.000Z',
      paymentMethod: 1,
      bankTransferType: 'Standard',
      amount: 4987.99,
      commission: 0.0,
      senderIntId: 42,
      senderExtId: 'ACC001',
      senderFirstName: 'Jane',
      senderLastName: 'Cooper',
      senderEmail: 'jane@company.com',
      senderBalance: null,
      senderIsCompany: false,
      senderCompanyName: null,
      receiverIntId: null,
      receiverExtId: null,
      receiverFirstName: null,
      receiverLastName: null,
      receiverEmail: null,
      receiverBalance: null,
      receiverIsCompany: null,
      receiverCompanyName: null,
      status: '20',
      statusBank: null,
      comment: 'Card money-in',
      isChargebackRelated: false,
      delayedDays: 0,
      rib: null,
      wkToken: null,
      merchantToken: null,
      sddMandate: null,
      collectionDate: null,
      settlementDate: '2025-03-12T10:00:00.000Z',
      scheduledDate: null,
      parentTransactionId: null,
      moneyOutId: null,
      HolderAuthenticationType: null,
      ChallengeMode: null,
      psp: null,
      pspError: null,
      PspReference: null,
      AccountBalance: null,
      category: 0,
      PaymentMeanDataProvider: null,
      Currency: 'EUR'
    },
    {
      id: 1005,
      type: 1,
      date: '2025-03-11T16:45:00.000Z',
      paymentMethod: 1,
      bankTransferType: 'Standard',
      amount: 4987.99,
      commission: 0.0,
      senderIntId: 42,
      senderExtId: 'ACC001',
      senderFirstName: 'Jane',
      senderLastName: 'Cooper',
      senderEmail: 'jane@company.com',
      senderBalance: null,
      senderIsCompany: false,
      senderCompanyName: null,
      receiverIntId: null,
      receiverExtId: null,
      receiverFirstName: null,
      receiverLastName: null,
      receiverEmail: null,
      receiverBalance: null,
      receiverIsCompany: null,
      receiverCompanyName: null,
      status: '20',
      statusBank: null,
      comment: 'Card money-in',
      isChargebackRelated: false,
      delayedDays: 0,
      rib: null,
      wkToken: null,
      merchantToken: null,
      sddMandate: null,
      collectionDate: null,
      settlementDate: '2025-03-11T18:00:00.000Z',
      scheduledDate: null,
      parentTransactionId: null,
      moneyOutId: null,
      HolderAuthenticationType: null,
      ChallengeMode: null,
      psp: null,
      pspError: null,
      PspReference: null,
      AccountBalance: null,
      category: 0,
      PaymentMeanDataProvider: null,
      Currency: 'EUR'
    }
  ]
};
